import {createHashHistory as history} from 'history';
import settings from 'Root/settings.json';

import {
  timerCancel,
} from 'App/util/redux/autoLogout/actions';
import {applicationClient as client} from 'App/index';
import {wsDisconnect, wsUnsubscribe} from 'App/util/redux/socket/actions';
import {authResetStorage} from 'App/util/redux/auth/actions';

export const minutesToDate = (min) => {
  const minutes = 1000 * 60;
  return (min * minutes);
};

export const getPath = (path = null) => {
  const paths = [
    '',
    settings.routing.root
  ];

  if (path) paths[2] = path;

  return paths.join('/');
};

export const cb_logout = (dispatch) => {
  dispatch(timerCancel());
  dispatch(wsUnsubscribe());
  dispatch(wsDisconnect());

  // resets redux storage and triggers callback afterwards
  dispatch(authResetStorage(() => {
      // clear apollo client storage and redirect to login
      client.resetStore();
    })
  );
};

export const cb_autoLogout = (dispatch) => cb_logout(dispatch);

export const cb_login = (dispatch, user) => {
  history().replace(getPath(''));
  client.resetStore();
};

export const handleInputChange = (event) => {
  const target = event.target;
  const value = target.value;
  const name = target.name;

  return {
    [name]: value,
  };
};

// if development mode
export const DEV_MODE = process.env.NODE_ENV === 'development';


// WEBPACK FOOTER //
// ./src/util/common/helper.js